// extracted by mini-css-extract-plugin
export default {"container":"Work_Experiences_container__AR2IW","projectsTitle":"Work_Experiences_projectsTitle__PIFSg"};